import { apiRequest } from '@/shared/api';

import type {
  AnswerDerbyPayload,
  AnswerDerbyResult,
  DerbyState,
} from '../model/types';

/**
 * `null` — открытого Дерби сейчас нет.
 *
 * Пустое тело ответа `fetch` разбирает как `null`, поэтому отдельного
 * признака «сейчас нечего проходить» в контракте нет.
 */
export function fetchCurrentDerby(): Promise<DerbyState | null> {
  return apiRequest<DerbyState | null>('/derby/current');
}

/**
 * Открыть Дерби — с этого вызова идёт таймер первого вопроса.
 *
 * Отвечает тем же, что и `fetchCurrentDerby`, вплоть до `null`.
 * Разница только в побочном действии на сервере, поэтому экран Дерби
 * зовёт это вместо чтения, а карточка в ленте матчей — по-прежнему
 * чтение: она таймер запускать не должна.
 */
export function startDerby(): Promise<DerbyState | null> {
  return apiRequest<DerbyState | null>('/derby/start', { method: 'POST' });
}

/**
 * Открыть следующий вопрос — с этого вызова идёт ЕГО таймер.
 *
 * Зовётся кнопкой «Следующий». Пока игрок читает фанфакт про предыдущий
 * вопрос, время не идёт: у каждого вопроса свой отсчёт с момента показа.
 *
 * Идемпотентен: повторный вызов на том же вопросе таймер не
 * перезапускает — иначе его сбрасывали бы нажатием кнопки.
 */
export function openNextDerbyQuestion(): Promise<DerbyState | null> {
  return apiRequest<DerbyState | null>('/derby/next', { method: 'POST' });
}

/**
 * Игрок закрыл приглашение «Дерби началось».
 *
 * Отметку держит сервер, а не браузер: в `localStorage` мини-аппа живёт
 * только токен, и приглашение вернулось бы на другом устройстве.
 */
export async function markDerbyNudgeSeen(): Promise<void> {
  await apiRequest<{ ok: true }>('/derby/nudge/seen', { method: 'POST' });
}

export function answerDerby(
  payload: AnswerDerbyPayload,
): Promise<AnswerDerbyResult> {
  return apiRequest<AnswerDerbyResult>('/derby/answer', {
    method: 'POST',
    body: payload,
  });
}
